import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export function NotFoundPage() {
  const h1Ref = useRef<HTMLHeadingElement | null>(null);
  useEffect(() => {
    h1Ref.current?.focus();
  }, []);
  return (
    <div>
      <h1 tabIndex={-1} ref={h1Ref}>
        Page not found
      </h1>
      <p>The page you tried to open isn't here, or you don't have access to it.</p>
      <p>
        <Link to="/">Return home</Link>
      </p>
    </div>
  );
}
